import type { Icons } from '@ksyos/design-system';
import {
    AccordionContent,
    AccordionContentIndent,
    AccordionItem,
    AccordionLink,
    AccordionListItem,
    AccordionTrigger,
    AccordionUnorderedList,
} from '@ksyos/design-system';
import { useUiStateContext } from '@frontend/utils/hooks/useUiState';
import { translateKey } from '../../../translate';

export interface IItem {
    name: string;
}

export interface IPatientSideBarCollapseProps {
    header: string;
    icon: Icons;
    listItems: IItem[];
    overviewLink: string;
    total: number;
}

export function PatientSideBarDetailCollapse(props: IPatientSideBarCollapseProps) {
    const { uiState, dispatchUiStateAction } = useUiStateContext();

    return (
        <AccordionItem value={props.header}>
            <AccordionTrigger icon={props.icon}>{`${props.header} (${props.total})`}</AccordionTrigger>
            <AccordionContent>
                <AccordionContentIndent>
                    <AccordionUnorderedList>
                        {props.listItems.map((item, i) => {
                            return <AccordionListItem key={i}>{item.name}</AccordionListItem>;
                        })}
                    </AccordionUnorderedList>
                    <AccordionLink
                        onClick={() => {
                            if (uiState.isTopBarOpen) {
                                return dispatchUiStateAction({ type: 'setIsTopBarOpen', isTopBarOpen: false });
                            }
                        }}
                        to={props.overviewLink}
                        variant="link"
                    >
                        {translateKey('common.seeOverview')}
                    </AccordionLink>
                </AccordionContentIndent>
            </AccordionContent>
        </AccordionItem>
    );
}
